import SignUpFeature from "./../features/SignUp";

export default function SignUp() {
  return <SignUpFeature />;
}
